import { createFileRoute } from '@tanstack/react-router';

import { NewInvestigationPage } from '@/components/Investigations/NewInvestigationPage';

// The list lives in the pane beside every investigations page, so the section's
// landing is the new-investigation screen rather than a full-page list.
export const Route = createFileRoute('/$organizationName/investigations/')({
  component: NewInvestigationPage,
});
